import {useMemo} from 'react'
import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {useThreads} from '../../../../../stores/layout-selectors'

export function useResolvedThreads(): Thread[] {
  const threads = useThreads()
  return useMemo(() => threads.filter(thread => thread.isResolved), [threads])
}
